import { useContext, useMemo } from "react";
import { ControlContext } from "../../ControlContext.jsx";

import { OTHERS } from "../../Helpers/OTHERS.jsx";
import { materialLoader } from "../../Helpers/materialLoader.jsx";

export default function Dibond({ depth }) {
  const {
    printWidth,
    printHeight,
    borderWidth,
    borderHeight,
    faceMountBackType,
  } = useContext(ControlContext);

  const totalWidth = printWidth + 2 * borderWidth;
  const totalHeight = printHeight + 2 * borderHeight;

  const blackMat = useMemo(() => materialLoader("Metal027", OTHERS, 'OTHERS', 1), []);
  const silverMat = useMemo(() => materialLoader("Metal009", OTHERS, 'OTHERS', 1), []);

  // Render four sides for a given material and z-position
  const renderSides = (material, zPosition, thickness) => {
    return (
      <group>
        {/* Top Side */}
        <mesh
          material={material}
          position={[0, totalHeight / 2, zPosition]}
          rotation={[-Math.PI / 2, 0, 0]}
        >
          <planeGeometry args={[totalWidth, thickness]} />
        </mesh>

        {/* Bottom Side */}
        <mesh
          material={material}
          position={[0, -totalHeight / 2, zPosition]}
          rotation={[-Math.PI / 2, 0, 0]}
        >
          <planeGeometry args={[totalWidth, thickness]} />
        </mesh>

        {/* Left Side */}
        <mesh
          material={material}
          position={[-totalWidth / 2, 0, zPosition]}
          rotation={[0, Math.PI / 2, 0]} // Rotate to match the left edge
        >
          <planeGeometry args={[thickness, totalHeight]} />
        </mesh>

        {/* Right Side */}
        <mesh
          material={material}
          position={[totalWidth / 2, 0, zPosition]}
          rotation={[0, Math.PI / 2, 0]} // Rotate to match the right edge
        >
          <planeGeometry args={[thickness, totalHeight]} />
        </mesh>
      </group>
    );
  };

  const renderBack = () => {
    switch (faceMountBackType) {
      case "Dibond":
        return (
          <group>
            {/* Top reflective silver layer */}
            {renderSides(silverMat, depth - 0.01, 0.02)}

            {/* Middle black core layer */}
            {renderSides(blackMat, depth - 0.15, 0.26)}

            {/* Bottom reflective silver layer */}
            {renderSides(silverMat, depth - 0.29, 0.02)}
            <mesh
              material={blackMat} // Use black material for the back plane
              position={[0, 0, depth - 0.31]} // Positioned behind all sides
              castShadow
              receiveShadow
            >
              <planeGeometry args={[totalWidth, totalHeight]} />
            </mesh>
          </group>
        );
      case "Chromaluxe":
        return (
          <group>
            {/* Single chromaluxe layer */}
            {renderSides(silverMat, depth - 0.1143 / 2, 0.1143)}
            <mesh
              material={blackMat} // Use black material for the back plane
              position={[0, 0, depth - 0.31]} // Positioned behind all sides
              castShadow
              receiveShadow
            >
              <planeGeometry args={[totalWidth, totalHeight]} />
            </mesh>
          </group>
        );
      default:
        return null;
    }
  };

  return renderBack();
}
